import { render, staticRenderFns } from "./EducatorReviewDetails.vue?vue&type=template&id=c1db74b8&scoped=true"
import script from "./EducatorReviewDetails.vue?vue&type=script&lang=js"
export * from "./EducatorReviewDetails.vue?vue&type=script&lang=js"
import style0 from "./EducatorReviewDetails.vue?vue&type=style&index=0&id=c1db74b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1db74b8",
  null
  
)

export default component.exports